import { sumProduct } from "../functions";
import { round } from "mathjs";
import type { AnnualConst, CalcOptions } from "../algorithm.types";

type CalculateAnnualGenerationParams = {
  calcOptions: Pick<CalcOptions, "noOfTechs" | "dayYearPercent">;
  annualConst: Pick<AnnualConst, "averageGenPerDay">;
};

export default function calculateAnnualGeneration({
  calcOptions,
  annualConst,
}: CalculateAnnualGenerationParams): Array<number> {
  const annualTechGen: Array<number> = [];
  for (let i = 0; i < calcOptions.noOfTechs; i++) {
    annualTechGen.push(
      (sumProduct(annualConst.averageGenPerDay[i], calcOptions.dayYearPercent) *
        24 *
        365) /
        1000,
    );
  }

  return annualTechGen.map((value) => round(value, 2));
}
